module.exports = __webpack_public_path__ + "img/sceneca_8.ff71b8be.png";